import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

// Simple sanitizer: only allows <b> tags, strips others
function sanitizeHtml(html) {
  // Remove all tags except <b>
  return html
    .replace(/<(?!\/?b\b)[^>]+>/gi, "")
    .replace(/<b>(.*?)<\/b>/gi, '<b class="highlighted">$1</b>');
}

// Function to strip all HTML tags and return plain text
function stripHtmlTags(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
}

export const HtmlCell = ({ 
  value, 
  onClick, 
  className, 
  editable = false, 
  onSave, 
  field,
  dataItem 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");

  useEffect(() => {
    if (isEditing) {
      // When entering edit mode, set the plain text value without HTML tags
      setEditValue(stripHtmlTags(value || ""));
    }
  }, [isEditing, value]);

  const handleCellClick = (e) => {
    if (editable) {
      setIsEditing(true);
    } else if (onClick) {
      onClick(e);
    }
  };

  const handleSave = () => {
    setIsEditing(false);
    if (onSave && editValue !== stripHtmlTags(value || "")) {
      onSave(editValue, field, dataItem);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setEditValue(stripHtmlTags(value || ""));
    }
  };

  if (isEditing) {
    return (
      <td className={className}>
        <Input
          type="text"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          autoFocus
          style={{ border: 'none', outline: 'none', background: 'transparent' }}
        />
      </td>
    );
  }

  return (
    <td
      onClick={handleCellClick}
      className={className}
      style={{ 
        cursor: (editable || onClick) ? "pointer" : "default",
        backgroundColor: editable ? "#f8f9fa" : "transparent"
      }}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(value || "") }}
    />
  );
};

HtmlCell.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  editable: PropTypes.bool,
  onSave: PropTypes.func,
  field: PropTypes.string,
  dataItem: PropTypes.object,
};

export default HtmlCell;